<template>
  <div class="row p-list-representation-wrapper align-items-start w-100">
        <div class="row w-100 p-list-representation-province-main pr-4 pl-4">

            <div class="w-100 d-flex flex-wrap p-list-representation-province-data-item mt-4 mb-4">
                  <div class="row p-salon-map-item ml-3 align-items-center">
                      <h3 class="p-salon-map-item-title">نام سالن:</h3>
                      <h3 class="p-salon-map-item-title mr-1">{{ formData.name || 'نامی ثبت نشده است' }}</h3>
                  </div>
                  <div class="row p-salon-map-item ml-3 align-items-center">
                      <h3 class="p-salon-map-item-title">نام صاحب سالن:</h3>
                      <h3 class="p-salon-map-item-title  mr-1">
                        {{ [formData.club.name, formData.club.family].join(' ') }}
                      </h3>
                  </div>
                  <button class="btn btn-primary btn-red remove-radius" @click="createSans">ثبت سانس</button>
              </div>

            <div class=" d-flex flex-wrap p-list-representation-province-data-item w-100">
                  <div class="row w-100 flex-column flex-lg-row">
                     <sansItems
                       @deleteSans="deleteSans"
                       @editSans="editSans"
                       :all-sans="allSans"
                     ></sansItems>
                  </div>
            </div>

        </div>

        <modalEditSalon :loading="loading" :active.sync="showModalEditSalon" @submitEdit="submitEdit" :form-data-original="formData" :current-data-item-sans="currentDataItemSans"></modalEditSalon>

        <modalCreateSalon
            @getSans="getSans"
            @updateLoading="updateLoading"
            :loading="loading"
            :hall-id="Number(formData.hall_id)"
            :active.sync="showModalCreateSalon" />

  </div>
</template>

<script>
import sansItems from './sansItems'
import modalEditSalon from './modalEditSalon'
import modalCreateSalon from './modalCreateSalon'

export default {
  name: 'contentList',
  components: {
    sansItems,
    modalEditSalon,
    modalCreateSalon
  },

  props: {
    allSans: { type: Array, default: [] },
    formData: { type: [Array, Object], default: {} },
    closeModal: { type: Number, default: 0 },
    loading: { type: Boolean, default: false }
  },

  data () {
    return {
      showModalEditSalon: false,
      showModalCreateSalon: false,
      currentDataItemSans: {}
    }
  },
  mounted () {
    console.log(this.formData)
  },
  watch: {
    closeModal () {
      this.showModalEditSalon = false
    }
  },
  methods: {
    updateLoading (data) {
      this.$emit('update:loading', data)
    },
    getSans () {
      this.$emit('getSans')
    },
    deleteSans (data) {
      this.$emit('deleteSans', data)
    },
    editSans (data) {
      this.showModalEditSalon = true
      this.currentDataItemSans = data
      this.$emit('editSans', data)
    },
    createSans () {
      this.showModalCreateSalon = true
    },
    submitEdit (data) {
      this.$emit('submitEditSansModal', data)
    }
  }

}
</script>
